var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvsDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cvs-2{fill:#1ca6ff;stroke:#1ca6ff;stroke-width:.8px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_cvs",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(10.584 10.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_002",
    transform: "translate(8.533 7.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_cvs",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_1241392_cc"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.865 14.8c.5 0 .909-.284.909-.635s-.407-.635-.909-.635H5.574c-.5 0-.909.284-.909.635s.407.635.909.635z",
    className: "cvs-2",
    transform: "translate(4.221 12.242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M11.819 0a6.71 6.71 0 0 0-6.572 5.559 5.807 5.807 0 0 0 .511 11.586h13.291v-1.05L5.758 15.92a4.593 4.593 0 0 1 0-9.185.609.609 0 0 0 .606-.555 5.5 5.5 0 0 1 5.455-4.956 5.115 5.115 0 0 1 3.807 1.646.6.6 0 0 0 .653.144 4.845 4.845 0 0 1 1.6-.258A4.267 4.267 0 0 1 22.123 6.5a.611.611 0 0 0 .4.507 4.617 4.617 0 0 1-1.61 8.917l-1.862.175v1.05h1.862a5.817 5.817 0 0 0 2.356-11.112 5.491 5.491 0 0 0-5.389-4.506 6.068 6.068 0 0 0-1.667.249A6.344 6.344 0 0 0 11.819 0z",
    className: "cvs-2",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M2.989 11.692c0 .351.407.635.909.635h14.675c.5 0 .909-.284.909-.635s-.407-.635-.909-.635H3.9c-.5 0-.911.285-.911.635z",
    className: "cvs-2",
    transform: "translate(2.705 10.006)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvsDefault);
export default __webpack_public_path__ + "static/media/cvs-default.8baa9ce1b5ff68086e70f15319205c05.svg";
export { ForwardRef as ReactComponent };